import './Header.css';
import React from 'react';
import dnsLogo from '../../Assets/DnsLogo.jpg';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <header>
        <Link to={'/'} class="dnsLogo">
          <img class="logo" src={dnsLogo}/>
        </Link>
        <nav class="fullSizeNav">
          <Link to={'/'} class="link">Home</Link>
          <Link class="dropdown link">
            <Link class="link">Services &#9660;</Link>
            <div class="dropdown-content">
              <Link to='/windows'>Windows</Link>
              <Link to='/roofing'>Roofing</Link>
              <Link to='/doors'>Doors</Link>
              <Link to='/painting'>Painting</Link>
              <Link to='/stucco'>Stucco</Link>
              <Link to='/gutters'>Gutters</Link>
            </div>
          </Link>
          <Link to='/about' class="link">About</Link>
          <Link to='/contact' class="link">Contact</Link>
        </nav>
        <nav class="MobileNav">
          <div class="ham-menu">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="off-screen-menu">
            <Link to={'/'} class="link">Home</Link>
            <Link class="dropdown link">
              <Link class="link">Services &#9660;</Link>
              <div class="dropdown-content">
                <Link to='/windows'>Windows</Link>
                <Link to='/roofing'>Roofing</Link>
                <Link to='/doors'>Doors</Link>
                <Link to='/painting'>Painting</Link>
                <Link to='/stucco'>Stucco</Link>
                <Link to='/gutters'>Gutters</Link>
              </div>
            </Link>
            <Link to='/about' class="link">About</Link>
            <Link to='/contact' class="link">Contact</Link>
          </div>
        </nav>
      <h4 class="fullSizeNav">(720) 278-0149</h4>
    </header>
  )
}

export default Header;
